import axios from "axios";
import API_URL from "../../ApiUrl";

  export const getArtikel = async () => {
    try {
      const response = await axios.get(
        API_URL.superStudent + "/api/v1/application/website/artikel",
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getKategoriArtikel = async () => {
    try {
      const response = await axios.get(
        API_URL.superStudent + "/api/v1/application/website/artikel-kategori",
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      return (response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
